import { SERVICE_BOOKING_API, ServiceBookingApi } from '@app/_services/service-booking-api';
import { Component, OnInit, Input, ChangeDetectorRef, Output, ViewChild, Inject } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray } from '@angular/forms';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import * as _ from 'lodash';
import * as moment from 'moment';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TimeRangeViewComponent } from '../single-date-inlinePicker/componenets/timeRange-view/timeRange-view.component';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-multi-day-picker',
    templateUrl: './multi-day-picker.component.html',
    styleUrls: ['./multi-day-picker.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MatDatepickerModule,
        TimeRangeViewComponent,
        NgFor,
        MatButtonModule,
        MatIconModule,
        DatePipe,
        TranslateModule,
    ],
})
export class MultiDayPickerComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder, @Inject(SERVICE_BOOKING_API) private bookingApi: ServiceBookingApi) {}

    //service item data
    @Input() product;
    @Input() timeType;
    @Input() form;
    @Input() disabledDates;


    availableFrom: Date;

    availableTo: Date;

    timeFrom: Date;
    timeTo: Date;

    selectedDate: Date;
    fetched: string[] = [];
    currentYearMonth: Date;


    @Input()dates;

    months = [
        '',
        'JAN',
        'FEB',
        'MAR',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC'
    ]

    onSelect(event) {
        var added = new Date(event)
        if (!this.dates.value) this.dates.setValue([]);
        let array = this.dates.value as Date[]
        let index = array?.findIndex((date:Date)=>{
            return date.getTime() === added.getTime();
        });
        // setValue (not an in-place push/splice) so listeners of the form see the change
        if(index == -1){
        this.dates.setValue([...array, added]);
        }
        this.selectedDate = added;
    }

    deleteDate(index){
            this.dates.setValue((this.dates.value as Date[]).filter((date, i) => i !== index));
            this.selectedDate = null;
    }

    weekday=[];
    initialized = false;
    today = new Date();
    maxDate = new Date( Date.now() + (3 * 30 * 24 * 60 * 60 * 1000) );

    ngOnInit(): void {
        this.maxDate = moment().add(6, 'months').toDate();
        this.initialized = true;
    }

    @ViewChild('calendar', {static: false}) calendar: MatCalendar<Date>;



    isSameMonthYear(dateA: Date, dateB: Date) {
        return dateA.getFullYear() == dateB.getFullYear() && dateA.getMonth() == dateB.getMonth();
    }

    getYearMonth(date: Date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}`;
    }

    getFullDate(date: Date) {
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${(date.getDate()).toString().padStart(2, '0')}`;
    }

    ngAfterViewInit() {
        this.disabledDates = this.disabledDates || [];
        this.currentYearMonth = new Date();
        this.calendar?.stateChanges?.subscribe((res) => {
            let activeDate = this.calendar.activeDate;
            if (this.fetched.includes(this.getYearMonth(activeDate))) return;
            if (!this.isSameMonthYear(activeDate, this.currentYearMonth)) {
                this.currentYearMonth = activeDate;
                let date = moment(activeDate);
                this.bookingApi.getDisabledDates(this.product._id, date.startOf('month').toISOString(), date.endOf('month').toISOString()).subscribe(
                    (result) => {
                        if (result.code == 200) {
                            this.disabledDates = this.disabledDates.concat(result.data);
                        }
                        this.fetched.push(this.getYearMonth(activeDate));
                        this.dateFilter = this.dateFilterFunction();
                    }
                );
            }
        });
        this.fetched.push(this.getYearMonth(new Date()));
        this.dateFilter = this.dateFilterFunction();
    }

    dateFilterFunction() {
        return (date: Date) => {
            if (!this.fetched.includes(this.getYearMonth(date))) return false;
            if (_.isEmpty(this.disabledDates)) return true;
            return !this.disabledDates.includes(this.getFullDate(date));
        };
    }

    //filter out non-work days and or booked days
    dateFilter = this.dateFilterFunction();

}
